"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiAwsCredentials = void 0;
const trace_1 = require("./util/trace");
class ApiAwsCredentials {
    constructor(current, refreshAuth) {
        this.refreshAuth = refreshAuth;
        (0, trace_1.trace)({ msg: `ApiAwsCredentials.ctor`, current });
        this.accessKeyId = current.aws.accessKeyId;
        this.secretAccessKey = current.aws.secretKey;
        this.sessionToken = current.aws.sessionToken;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    refresh(callback) {
        (0, trace_1.trace)({ msg: `ApiAwsCredentials.refresh` });
        this.refreshPromiseInternal().then(() => callback(), callback);
    }
    async refreshPromiseInternal() {
        (0, trace_1.trace)({ msg: `ApiAwsCredentials.refreshPromiseInternal` });
        const creds = await this.refreshAuth();
        if (!creds) {
            throw new Error(`can't refresh credentials`);
        }
        this.accessKeyId = creds.aws.accessKeyId;
        this.secretAccessKey = creds.aws.secretKey;
        this.sessionToken = creds.aws.sessionToken;
    }
}
exports.ApiAwsCredentials = ApiAwsCredentials;
//# sourceMappingURL=ApiAwsCredentials.js.map